// Constants
import { SERVICE_DOMAINS } from '../constants/services';

// Utilities
import { request } from '../utilities/http';

export interface IGetPersonRequest {
    params: { networkId: string };
    query: { userId: string };
}

export interface IGetPersonResponse {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    photoUrl: string;
    lastLogin: string;
    role: string;
}

export function getPerson({ params, query }: IGetPersonRequest): Promise<IGetPersonResponse> {
    return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.get`, {
        method: 'GET',
        query
    });
}

export interface IGetPeopleRequest {
    params: { networkId: string };
}

export interface IGetPeopleResponse {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    photoUrl: string;
    lastLogin: string;
}

export function getPeople({ params }: IGetPeopleRequest): Promise<IGetPeopleResponse[]> {
    return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.list`, {
        method: 'GET'
    });
}

export interface IEditPersonRequest {
    params: { networkId: string };
    query: { userId: string };
    body: {
        email: string;
        mobile: string;
    };
}

export interface IEditPersonResponse {
    userId: string;
    firstName: string;
    lastName: string;
    email: string;
    mobile: string;
    photoUrl: string;
    lastLogin: string;
}

export function editPerson({ params, body, query }: IEditPersonRequest): Promise<IEditPersonResponse> {
    return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.edit`, {
        method: 'POST',
        query,
        body: JSON.stringify(body)
    });
}

export interface IDeletePersonRequest {
    params: { networkId: string };
    query: { userId: string };
}

export interface IDeletePersonResponse {
}

export function deletePerson({ params, query }: IDeletePersonRequest): Promise<IDeletePersonResponse> {
    return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.delete`, {
        method: 'GET',
        query,
    });
}

export interface IGetPersonTagsRequest {
    params: { networkId: string };
    query: { userId: string };
}

export interface IGetPersonTagsResponse {
    tagId: string;
    pathName: string;
}

export function getPersonTags({ params, query }: IGetPersonTagsRequest): Promise<IGetPersonTagsResponse[]> {
    return request(`${SERVICE_DOMAINS.API}/v1/${params.networkId}/people.tags.list`, {
        method: 'GET',
        query
    });
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/services/person.ts